export default __webpack_public_path__ + "static/media/visual.2c09b1a8.png";